export default __webpack_public_path__ + "static/media/infra-20.8a436b00.webp";